import { HandwritterArrow, Icon } from '@maverick/ui';
import React from 'react';
import { DottedLine, FilterImg, ImgType } from '../DottedLine';
import * as Styled from './SectionBanner.styled';

export interface SectionProps {
	title: string;
	text: string;
	aside: string;
	image: string;
	bg: string;
	asideTop?: boolean;
	bgFixed?: boolean;
	withDottedLine?: boolean;
}

export const dottedLine = (
	<Styled.SectionDottedLine>
		<DottedLine img={ImgType.dottedLine} onlyMobile={false} filter={FilterImg.gray} />
	</Styled.SectionDottedLine>
);

export const SectionBanner: React.FC<SectionProps> = ({
	title,
	text,
	aside,
	image,
	bg,
	bgFixed,
	withDottedLine,
	asideTop,
}) => {
	return (
		<Styled.Section bg={bg} bgFixed={bgFixed} asideTop={asideTop} data-testid='section banner'>
			<Styled.SectionHolder>
				<Styled.SectionImage src={image} aria-hidden='true' tabIndex={-1} />
				<Styled.SectionAside>
					{!asideTop && (
						<React.Fragment>
							<div aria-hidden='true' tabIndex={-1}>
								<Icon icon={HandwritterArrow} customSize />
							</div>
							<aside role='presentation'>{aside}</aside>
						</React.Fragment>
					)}
					{asideTop && (
						<React.Fragment>
							<aside role='presentation'>{aside}</aside>
							<div aria-hidden='true' tabIndex={-1}>
								<Icon icon={HandwritterArrow} customSize />
							</div>
						</React.Fragment>
					)}
				</Styled.SectionAside>
				<Styled.SectionContent>
					{withDottedLine && dottedLine}
					<h2>{title}</h2>
					<p>{text}</p>
					{withDottedLine && dottedLine}
				</Styled.SectionContent>
			</Styled.SectionHolder>
		</Styled.Section>
	);
};
